import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { NetworkType } from '..';
import { BlockExplorer } from './block-explorer';
export var TezblockBlockExplorer = /*#__PURE__*/function (_BlockExplorer) {
  _inherits(TezblockBlockExplorer, _BlockExplorer);

  var _super = _createSuper(TezblockBlockExplorer);

  function TezblockBlockExplorer() {
    var _ref;

    var _this;

    var rpcUrls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_ref = {}, _defineProperty(_ref, NetworkType.MAINNET, 'https://tezblock.io'), _defineProperty(_ref, NetworkType.DELPHINET, 'https://delphinet.tezblock.io'), _defineProperty(_ref, NetworkType.EDONET, 'https://edonet.tezblock.io'), _defineProperty(_ref, NetworkType.FLORENCENET, 'https://florencenet.tezblock.io'), _defineProperty(_ref, NetworkType.GRANADANET, 'https://granadanet.tezblock.io'), _defineProperty(_ref, NetworkType.HANGZHOUNET, 'https://hangzhounet.tezblock.io'), _defineProperty(_ref, NetworkType.IDIAZABALNET, 'https://idiazabalnet.tezblock.io'), _defineProperty(_ref, NetworkType.CUSTOM, 'https://granadanet.tezblock.io'), _ref);

    _classCallCheck(this, TezblockBlockExplorer);

    _this = _super.call(this, rpcUrls);
    _this.rpcUrls = rpcUrls;
    return _this;
  }

  _createClass(TezblockBlockExplorer, [{
    key: "getAddressLink",
    value: function getAddressLink(address, network) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var blockExplorer;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getLinkForNetwork(network);

              case 2:
                blockExplorer = _context.sent;
                return _context.abrupt("return", "".concat(blockExplorer, "/account/").concat(address));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getTransactionLink",
    value: function getTransactionLink(transactionId, network) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var blockExplorer;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getLinkForNetwork(network);

              case 2:
                blockExplorer = _context2.sent;
                return _context2.abrupt("return", "".concat(blockExplorer, "/transaction/").concat(transactionId));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return TezblockBlockExplorer;
}(BlockExplorer);